export default "__VITE_ASSET__DMaChpIE__"